/*
* Import a bunch of packages and make them available globally
* Please keep .eslintrc up to date with these
*/

/* Required by ng-pickadate */
import Picker from 'pickadate/lib/picker.js';
import 'pickadate/lib/picker.date.js';
import 'pickadate/lib/picker.time.js';
window.Picker = Picker;

import _ from 'lodash';
window._ = _;

/* Small hack, to get ngHandsonTable to load, hook is unused anyway */
window.Handsontable = {hooks: {add: () => {}}};

import 'magnific-popup';
